import Cleave from 'cleave.js/react'
import 'cleave.js/dist/addons/cleave-phone.i18n'
import { useFieldError } from '~/components/FormContext'

type MaskedInputInputProps = {
  name: string
  label: string
  placeholder?: string
  value?: string
  options: CleaveOptions
}

type CleaveOptions = {
  prefix?: string
  blocks: number[]
}

export const MaskedInput = ({ name, label, placeholder, options }: MaskedInputInputProps) => {
  const error = useFieldError(name)

  return (
    <div className="mb-5 mr-4 w-full sm:w-2/5 xl:w-[48%] print:mb-2 print:w-[44%]">
      <label htmlFor={name} className="block">
        <span className="text-gray-700">{label}</span>
        <Cleave
          options={options}
          id={name}
          name={name}
          type="text"
          className="mt-1 block w-full rounded print:pt-2 print:text-sm"
          placeholder={placeholder || label}
        />
        {error && <p className="font-bold text-red-900">{error}</p>}
      </label>
    </div>
  )
}
